export enum SalesOrderForceCompleteActionEnum {
  CANCEL = 'cancel',
  REMOVE = 'remove',
}
